// Video tutorial data organized by skill level category
// Videos are stored in Firebase Storage at: dashone_tutorial_videos/
// Thumbnails are stored in Firebase Storage at: dashone_tutorial_thumbnails/

export const videoCategories = [
  {
    id: "essentials",
    title: "The Essentials (Beginner)",
    videos: [
      {
        id: "1",
        category: "Market Overview",
        title: "Understanding the One Score & KPIs",
        sectionName: "Market Overview",
        shortDescription: "Understanding the One Score & KPIs",
        description:
          "An introduction to the One Score. This video explains how the One Score is calculated as a single weighted number based on configurable KPIs like Availability, Bundles, Image Presence, and Name Accuracy. It covers how to read the top-level metrics to understand store execution quality.",
        storagePath: "Understanding the one Score & KPIs [Market Overview].mp4",
        thumbnailPath: "Understanding the one Score & KPIs [Market Overview].jpg",
        duration: "0:24",
      },
      {
        id: "3",
        category: "Execution View",
        title: "Filtering, Searching, and Saving Lists",
        sectionName: "Execution View",
        shortDescription: "Filtering, Searching, and Saving Lists",
        description:
          "Master the art of filtering and searching through your data. This video covers how to use advanced filters, create custom searches, and save your lists for quick access later. Perfect for streamlining your workflow.",
        storagePath: "Filtering, Searching, and Saving Lists [Execution View].mp4",
        thumbnailPath: "Filtering, Searching, and Saving Lists [Execution View].jpg",
        duration: "0:40",
      },
    ],
  },
  {
    id: "tactical",
    title: "Tactical Execution (Intermediate)",
    videos: [
      {
        id: "4",
        category: "Execution View",
        title: 'Finding "Low Hanging Fruit" Opportunities',
        sectionName: "Execution View",
        shortDescription: 'Finding "Low Hanging Fruit" Opportunities',
        description:
          'Discover how to identify quick wins and easy opportunities for improvement. This video teaches you how to spot "low hanging fruit" in your execution data that can lead to immediate performance gains with minimal effort.',
        storagePath: "Finding _Low Hanging Fruit_ Opportunities [Execution View].mp4",
        thumbnailPath: "Finding _Low Hanging Fruit_ Opportunities [Execution View].jpg",
        duration: "0:29",
      },
      {
        id: "5",
        category: "Execution View",
        title: "Checking Content Adherence",
        sectionName: "Execution View",
        shortDescription: "Checking Content Adherence (Images & Naming)",
        description:
          "Learn how to verify that your content meets brand standards. This video covers checking image quality, naming conventions, and overall content adherence to ensure consistency across all platforms.",
        storagePath: "Checking Content Adherence (Images & Naming) [Execution View].mp4",
        thumbnailPath: "Checking Content Adherence (Images & Naming) [Execution View].jpg",
        duration: "0:35",
      },
      {
        id: "6",
        category: "Execution View",
        title: "Ensuring Full Core Brand Compliance",
        sectionName: "Execution View",
        shortDescription: "Ensuring Full Core Brand Compliance",
        description:
          "A comprehensive guide to maintaining brand compliance across your portfolio. Learn how to monitor, track, and ensure that all core brand elements are properly represented in your execution.",
        storagePath: "_Ensuring Full Core Brand Compliance [Execution View].mp4",
        thumbnailPath: "_Ensuring Full Core Brand Compliance [Execution View].jpg",
        duration: "0:46",
      },
      {
        id: "7",
        category: "Execution View",
        title: "Analyzing Combo & Meal Execution",
        sectionName: "Execution View",
        shortDescription: "Analyzing Combo & Meal Execution",
        description:
          "Deep dive into combo and meal execution analysis. This video explains how to track bundle performance, identify gaps in meal offerings, and optimize your combo strategies for better results.",
        storagePath: "Analyzing Combo & Meal Execution [Execution View].mp4",
        thumbnailPath: "Analyzing Combo & Meal Execution [Execution View].jpg",
        duration: "0:32",
      },
      {
        id: "8",
        category: "Execution View",
        title: "Tracking Competitors using 'Add SKU'",
        sectionName: "Execution View",
        shortDescription: "Tracking Competitors using 'Add SKU'",
        description:
          "Learn how to monitor your competitors effectively using the Add SKU feature. This video shows you how to add competitor products to your tracking list and analyze their market presence.",
        storagePath: "Tracking Competitors using 'Add SKU' [Execution View] .mp4",
        thumbnailPath: "Tracking Competitors using 'Add SKU' [Execution View] .jpg",
        duration: "0:33",
      },
    ],
  },
  {
    id: "strategic",
    title: "Strategic Monitoring (Advanced)",
    videos: [
      {
        id: "9",
        category: "My Lists",
        title: "Tracking Performance Trends Over Time",
        sectionName: "My Lists",
        shortDescription: "Tracking Performance Trends Over Time",
        description:
          "Master long-term performance tracking with My Lists. This video demonstrates how to monitor trends over time, set up automated tracking, and gain insights into your performance trajectory.",
        storagePath: "Tracking Performance Trends Over Time [My List].mp4",
        thumbnailPath: "Tracking Performance Trends Over Time [My List].jpg",
        duration: "0:32",
      },
      {
        id: "10",
        category: "Market Deepdive",
        title: "Analyzing Retention, Acquisition, and Churn",
        sectionName: "Market Deepdive",
        shortDescription: "Analyzing Retention, Acquisition, and Churn",
        description:
          "A strategic guide to understanding customer dynamics. Learn how to analyze retention rates, acquisition costs, and churn patterns to make data-driven decisions for your business.",
        storagePath: "Analyzing Retention, Acquisition, and Churn [Market Deepdive].mp4",
        thumbnailPath: "Analyzing Retention, Acquisition, and Churn [Market Deepdive].jpg",
        duration: "0:36",
      },
      {
        id: "11",
        category: "Market Deepdive",
        title: "Identifying Gaps and White Space Opportunities",
        sectionName: "Market Deepdive",
        shortDescription: "Identifying Gaps and White Space Opportunities",
        description:
          "Discover untapped market potential with gap analysis. This video teaches you how to identify white space opportunities in your market and develop strategies to capitalize on them.",
        storagePath: "Identifying Gaps and White Space Opportunities [Market Deepdive].mp4",
        thumbnailPath: "Identifying Gaps and White Space Opportunities [Market Deepdive].jpg",
        duration: "0:31",
      },
      {
        id: "12",
        category: "Market Deepdive",
        title: "Tracking Core Brand Penetration",
        sectionName: "Market Deepdive",
        shortDescription: "Tracking Core Brand Penetration",
        description:
          "Learn advanced techniques for monitoring brand penetration across markets. This video covers how to track your core brand presence and identify opportunities for expansion.",
        storagePath: "_Tracking Core Brand Penetration [Market Deepdive].mp4",
        thumbnailPath: "_Tracking Core Brand Penetration [Market Deepdive].jpg",
        duration: "0:26",
      },
      {
        id: "13",
        category: "Market Overview",
        title: "Benchmarking Across Regions and Platforms",
        sectionName: "Market Overview",
        shortDescription: "Benchmarking Across Regions and Platforms",
        description:
          "Compare performance across different regions and platforms. This video explains how to set up benchmarks, analyze regional differences, and optimize your multi-platform strategy.",
        storagePath: "Benchmarking Across Regions and Platforms [Market Overview].mp4",
        thumbnailPath: "Benchmarking Across Regions and Platforms [Market Overview].jpg",
        duration: "0:29",
      },
    ],
  },
];
